(() => {
  const root = document.querySelector('[data-purchase-popup]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const key = 'nrh-purchase-popup-dismissed';
  try { if (sessionStorage.getItem(key) === '1') return; } catch (_) {}
  const items = Array.from(root.querySelectorAll('[data-purchased-at]'));
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const randomDelay = () => (2 + Math.floor(Math.random() * 14)) * 1000;
  const day = 86400000;
  const updated = Date.parse(root.dataset.updatedAt);
  let index = -1, dismissed = false, hovering = false, started = false;
  let lastChange = 0;
  let interval = randomDelay();
  function fresh(item, now) {
    const purchased = Date.parse(item.dataset.purchasedAt);
    return Number.isFinite(purchased) && now >= purchased && now - purchased < 30 * day;
  }
  function healthy(now) {
    return Number.isFinite(updated) && now >= updated && now - updated < 2 * day;
  }
  function blocked() {
    return document.hidden || document.body.classList.contains('modal-open') || document.querySelector('dialog[open]');
  }
  function showNext() {
    const now = Date.now();
    if (dismissed || !healthy(now)) { root.hidden = true; return false; }
    const eligible = items.map((item, i) => fresh(item, now) ? i : -1).filter(i => i >= 0);
    const choices = eligible.length > 1 ? eligible.filter(i => i !== index) : eligible;
    const found = choices.length ? choices[Math.floor(Math.random() * choices.length)] : -1;
    if (found < 0) { root.hidden = true; return false; }
    items.forEach((item, i) => { item.hidden = i !== found; });
    index = found;
    const img = items[index].querySelector('img[data-src]');
    if (img && !img.getAttribute('src')) img.src = img.dataset.src;
    root.hidden = Boolean(blocked());
    lastChange = now;
    interval = randomDelay();
    return true;
  }
  root.querySelector('[data-purchase-close]').addEventListener('click', () => {
    dismissed = true;
    root.hidden = true;
    clearInterval(timer);
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  });
  root.addEventListener('mouseenter', () => { hovering = true; });
  root.addEventListener('mouseleave', () => { hovering = false; lastChange = Date.now(); });
  root.addEventListener('focusout', () => { lastChange = Date.now(); });
  document.addEventListener('visibilitychange', () => { lastChange = Date.now(); });
  motion.addEventListener('change', () => { lastChange = Date.now(); });
  const readyAt = Date.now() + interval;
  const timer = setInterval(() => {
    const now = Date.now();
    if (!healthy(now) || dismissed || !items.some(item => fresh(item, now))) {
      root.hidden = true;
      clearInterval(timer);
      return;
    }
    if (blocked()) { root.hidden = true; lastChange = now; return; }
    if (!started) {
      if (now >= readyAt) started = showNext();
      return;
    }
    if (!fresh(items[index], now)) { showNext(); return; }
    root.hidden = false;
    if (!motion.matches && !hovering && !root.contains(document.activeElement) && now - lastChange >= interval) showNext();
  }, 1000);
})();

